export default (rootRoute, subRoute) => {
  return `${rootRoute}${subRoute}`;
};
